var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLabel = function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3F3F46",
    clipPath: "url(#label_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.322 8.01-1.437-4.06a.47.47 0 0 0-.344-.305L7.335 2.72a1.42 1.42 0 0 0-1.366.446L2.27 7.35a2.364 2.364 0 0 0 .207 3.333l3.54 3.127a2.364 2.364 0 0 0 3.333-.206l3.697-4.185a1.42 1.42 0 0 0 .274-1.41m-4.68 4.97a1.417 1.417 0 0 1-2 .123L3.104 9.976a1.417 1.417 0 0 1-.124-2l3.697-4.185a.47.47 0 0 1 .457-.15l3.949.87 1.35 3.812a.47.47 0 0 1-.092.472z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.094 6.761a.708.708 0 1 0 .938-1.062.708.708 0 0 0-.938 1.062"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "label_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.505 0 16 7.505 8.495 16 0 8.495z"
  })))));
};
export default SvgLabel;